<div class="form-container">
    <form [formGroup]="form" class="form">
        <div class="row">
            <mat-form-field>
                <input matInput formControlName="name" placeholder="Name" required/>
                <mat-error>Required and cannot be longer than 100 characters</mat-error>
            </mat-form-field>
            <mat-form-field>
                <input matInput formControlName="website" placeholder="Website"/>
                <mat-error>Cannot be longer than 100 characters</mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field>
                <input matInput formControlName="cbNumber" placeholder="Credit Bureau Number"/>
                <mat-error>Cannot be longer than 10 characters</mat-error>
            </mat-form-field>
            <mat-form-field>
                <input matInput formControlName="cbRating" placeholder="Credit Bureau Rating"/>
                <mat-error>Cannot be longer than 5 characters</mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field>
                <mat-label>Credit Bureau Date</mat-label>
                <input matInput (focus)="cbDatePicker.open()" (click)="cbDatePicker.open()" readonly [matDatepicker]="cbDatePicker" formControlName="cbDate" autocomplete="off">
                <mat-datepicker-toggle matSuffix [for]="cbDatePicker" disabled="false"></mat-datepicker-toggle>
                <mat-datepicker #cbDatePicker disabled="false"></mat-datepicker>
            </mat-form-field>
            <mat-form-field>
                <input matInput formControlName="companyRegistrationNumber" placeholder="Company Registration Number"/>
                <mat-error>Cannot be longer than 20 characters</mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field>
                <input matInput formControlName="creditVettingCode" placeholder="Credit Vetting Code"/>
                <mat-error>Cannot be longer than 20 characters</mat-error>
            </mat-form-field>
            <mat-form-field>
                <input matInput formControlName="vatRegistrationNumber" placeholder="VAT Registration Number"/>
                <mat-error>Cannot be longer than 20 characters</mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field>
                <input matInput required formControlName="emailAddress" placeholder="Email Address" type="email"/>
                <mat-error>Required and cannot be longer than 500 characters</mat-error>
            </mat-form-field>
        </div>
        <div class="banks">
            <div *ngFor="let bank of getBanks().controls; let index = index" class="form-section">
                <div class="delete-section"><span class="delete-link" (click)="removeBank(index)"><mat-icon>close</mat-icon></span></div>
                <div class="row">
                    <mat-form-field>
                        <mat-select required placeholder="Name" [formControl]="bank.get('name')">
                            <mat-option *ngFor ="let bankName of bankNames$ | async" [value]="bankName">{{bankName}}</mat-option>
                        </mat-select>
                        <mat-error>Required</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput required [formControl]="bank.get('ibtCode')" placeholder="IBT Code"/>
                        <mat-error>Required and cannot be longer than 8 characters</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field>
                        <mat-select placeholder="Account Type" required [formControl]="bank.get('accountType')">
                            <mat-option *ngFor ="let accountType of bankAccountTypes$ | async" [value]="accountType">{{accountType}}</mat-option>
                        </mat-select>
                        <mat-error>Required</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput required [formControl]="bank.get('accountHolderName')" placeholder="Account Holder Name"/>
                        <mat-error>Required and cannot be longer than 60 characters</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field>
                        <input matInput required [formControl]="bank.get('accountNumber')" placeholder="Account Number"/>
                        <mat-error>Required and cannot be longer than 20 characters</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field>
                        <input matInput required [formControl]="bank.get('mandateAuthorisedName')" placeholder="Mandate Authorised Name"/>
                        <mat-error>Required and cannot be longer than 50 characters</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Mandate Received</mat-label>
                        <input matInput required (focus)="picker.open()" (click)="picker.open()" readonly [matDatepicker]="picker" [formControl]="bank.get('mandateReceived')" autocomplete="off">
                        <mat-datepicker-toggle matSuffix [for]="picker" disabled="false"></mat-datepicker-toggle>
                        <mat-datepicker #picker disabled="false"></mat-datepicker>
                        <mat-error>Required</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field>
                        <input matInput required type="number" [formControl]="bank.get('mandateDayFirst')" placeholder="Mandate Day First"/>
                        <mat-error>Required and must be between 1-31</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput required type="number" [formControl]="bank.get('mandateDayRest')" placeholder="Mandate Day Rest"/>
                        <mat-error>Required and must be between 1-31</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-checkbox [formControl]="bank.get('isDefault')">Default</mat-checkbox>
                </div>
            </div>
        </div>
        <mat-error *ngIf="getBanks().hasError('required')">At least one bank is required</mat-error>
        <a  mat-raised-button (click)="addBank()">Add Bank</a>

        <div class="billToAddresses">
            <div *ngFor="let billToAddress of getBillToAddresses().controls; let index = index" class="form-section">
                <div class="delete-section"><span class="delete-link" (click)="removeBillToAddress(index)"><mat-icon>close</mat-icon></span></div>
                <div class="row">
                    <mat-form-field>
                        <input matInput required [formControl]="billToAddress.get('addressLine1')" placeholder="Address Line 1"/>
                        <mat-error>Required and cannot be longer than 60 characters</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput required [formControl]="billToAddress.get('addressLine2')" placeholder="Address Line 2"/>
                        <mat-error>Required and cannot be longer than 60 characters</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field>
                        <input matInput required [formControl]="billToAddress.get('addressLine3')" placeholder="Address Line 3"/>
                        <mat-error>Required and cannot be longer than 60 characters</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput [formControl]="billToAddress.get('addressLine4')" placeholder="Address Line 4"/>
                        <mat-error>cannot be longer than 60 characters</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field>
                        <input matInput required [formControl]="billToAddress.get('postalCode')" placeholder="Postal Code"/>
                        <mat-error>Required and cannot be longer than 10 characters</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput required [formControl]="billToAddress.get('city')" placeholder="City"/>
                        <mat-error>Required and cannot be longer than 30 characters</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field>
                        <input matInput required [formControl]="billToAddress.get('province')" placeholder="Province"/>
                        <mat-error>Required and cannot be longer than 30 characters</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-checkbox [formControl]="billToAddress.get('isDefault')">Default</mat-checkbox>
                </div>
            </div>
        </div>
        <mat-error *ngIf="getBillToAddresses().hasError('required')">At least one bill to address is required</mat-error>
        <a  mat-raised-button (click)="addBillToAddress()">Add Bill To Address</a>

        <div class="contactPersons">
            <div *ngFor="let contactPerson of getContactPersons().controls; let index = index" class="form-section">
                <div class="delete-section"><span class="delete-link" (click)="removeContactPerson(index)"><mat-icon>close</mat-icon></span></div>
                <div class="row">
                    <mat-form-field>
                        <input matInput required [formControl]="contactPerson.get('firstName')" placeholder="First Name"/>
                        <mat-error>Required and cannot be longer than 60 characters</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput required [formControl]="contactPerson.get('surname')" placeholder="Surname"/>
                        <mat-error>Required and cannot be longer than 60 characters</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field>
                        <input matInput required [formControl]="contactPerson.get('title')" placeholder="Title"/>
                        <mat-error>Required and cannot be longer than 5 characters</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput required [formControl]="contactPerson.get('contactPosition')" placeholder="Contact Position"/>
                        <mat-error>Required and cannot be longer than 30 characters</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field>
                        <input matInput required type="tel" [formControl]="contactPerson.get('phoneNumber')" placeholder="Phone Number"/>
                        <mat-error>Required and cannot be longer than 30 characters</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput type="tel" [formControl]="contactPerson.get('faxNumber')" placeholder="Fax Number"/>
                        <mat-error>Cannot be longer than 30 characters</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field>
                        <input matInput type="tel" [formControl]="contactPerson.get('mobileNumber')" placeholder="Mobile Number"/>
                        <mat-error>Mobile Number cannot be longer than 30 characters</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput required type="email" [formControl]="contactPerson.get('emailAddress')" placeholder="Email Address"/>
                        <mat-error>Required and cannot be longer than 200 characters</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-checkbox [formControl]="contactPerson.get('isDefault')">Default</mat-checkbox>
                    <mat-checkbox [formControl]="contactPerson.get('isContractSigner')">Contract Signer</mat-checkbox>
                </div>
            </div>
        </div>
        <mat-error *ngIf="getContactPersons().hasError('required')">At least one contact person is required</mat-error>
        <a  mat-raised-button (click)="addContactPerson()">Add Contact Person</a>

        <div class="contracts">
            <div *ngFor="let contract of getContracts().controls; let index = index" class="form-section">
                <div class="delete-section"><span class="delete-link" (click)="removeContract(index)"><mat-icon>close</mat-icon></span></div>
                <div class="row">
                    <mat-form-field>
                        <mat-select required placeholder="Book Code" [formControl]="contract.get('bookCode')">
                            <mat-option *ngFor ="let bookCode of bookCodes$ | async" [value]="bookCode.id">{{bookCode.id }} - {{bookCode.value}}</mat-option>
                        </mat-select>
                        <mat-error>Required</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-select required placeholder="Edition" [formControl]="contract.get('edition')">
                            <mat-option *ngFor ="let o of editions$ | async" [value]="o.id">{{o.id }} - {{o.value}}</mat-option>
                        </mat-select>
                        <mat-error>Required</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field>
                        <input matInput required [formControl]="contract.get('programId')" placeholder="Program ID"/>
                        <mat-error>Required</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput required [formControl]="contract.get('referenceNumber')" placeholder="Reference Number"/>
                        <mat-error>Required and cannot be longer than 30 characters</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field>
                        <input matInput required type="number" [formControl]="contract.get('canvas')" placeholder="Canvas"/>
                        <mat-error>Required and cannot be longer than 2 characters</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput required type="number" [formControl]="contract.get('canvasYear')" placeholder="Canvas Year"/>
                        <mat-error>Required and cannot be longer than 2 characters</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field>
                        <mat-select required placeholder="Pay Source" [formControl]="contract.get('paySourceId')">
                            <mat-option *ngFor ="let o of paySources$ | async" [value]="o.id">{{o.id }} - {{o.value}}</mat-option>
                        </mat-select>
                        <mat-error>Required</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-select required placeholder="Pay Method" [formControl]="contract.get('payMethodId')">
                            <mat-option *ngFor ="let o of payMethods$ | async" [value]="o.id">{{o.id }} - {{o.value}}</mat-option>
                        </mat-select>
                        <mat-error>Required</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field>
                        <input matInput required type="tel" [formControl]="contract.get('billingPhoneNumber')" placeholder="Billing Phone Number"/>
                        <mat-error>Required and cannot be longer than 20 characters</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput type="number" required [formControl]="contract.get('totalNumberOfBillingPeriods')" placeholder="Billing Periods"/>
                        <mat-error>Required</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field>
                        <input matInput required type="number" [formControl]="contract.get('totalContractAmountExclTax')" placeholder="Amount Excluding Tax"/>
                        <mat-error>Amount Excluding Tax is required</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput required type="number" [formControl]="contract.get('totalVolumeDiscountAmountExclTax')" placeholder="Discount Amount Excluding Tax"/>
                        <mat-error>Required</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <mat-form-field>
                        <input matInput required [formControl]="contract.get('repCode')" placeholder="Rep Code"/>
                        <mat-error>Required and cannot be longer than 10 characters</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <mat-error *ngIf="getContracts().hasError('required')">At least one contract is required</mat-error>
        <a  mat-raised-button (click)="addContract()">Add Contract</a>
        <button mat-raised-button type="submit" color="primary" (click)="onSubmit()">Submit</button>
    </form>
</div>
